import { isSyntheticCheckMode } from './synthetic-check-mode';

export const testId = (id: string) => {
  if (
    process.env.NODE_ENV === 'test' ||
    process.env.MODE === 'test' ||
    process.env.MODE === 'ddev' ||
    isSyntheticCheckMode()
  ) {
    return id;
  }
  return undefined;
};
